import React, {useEffect, useState} from 'react';
import {Card, Empty, Flex, Modal, Spin, Table} from "antd";
import IntlMessage, {IntlMessageText} from "../../IntlMessage/IntlMessage";
import {LocalName} from "../../../utils/LocalName";
import GroupService from "../../../services/GroupService";
import MyText from "../Text/MyText";

const DAY_ORDER = [1, 2, 3, 4, 5, 6, 7];

/**
 * п.10: показывает преподавателю полное расписание ученика по всем дисциплинам
 * (кросс-групповое), включая сводную неделю и разбивку по группам.
 */
const StudentScheduleModal = ({open, onClose, studentId, studentName}) => {
    const [loading, setLoading] = useState(false);
    const [schedule, setSchedule] = useState([]);

    useEffect(() => {
        if (open && studentId) {
            setLoading(true);
            GroupService.getStudentSchedule(studentId)
                .then((data) => setSchedule(data || []))
                .catch(() => setSchedule([]))
                .finally(() => setLoading(false));
        }
    }, [open, studentId]);

    // ТЗ updated п.11: показываем номер группы — без него «General English 3» и «General English 7»
    // в расписании выглядели одинаково
    const courseName = (g) => {
        const base = LocalName.getName(g.course) || LocalName.getName(g.name);
        const groupLabel = [LocalName.getName(g.name), g.number].filter(Boolean).join(' ');
        return groupLabel && groupLabel !== base ? `${base} (${groupLabel})` : base;
    };

    // Сводная неделя: день недели -> список занятий
    const byDay = {};
    schedule.forEach(g => {
        (g.slots || []).forEach(s => {
            if (!byDay[s.dayOfWeek]) {
                byDay[s.dayOfWeek] = {dayName: s.dayName, items: []};
            }
            byDay[s.dayOfWeek].items.push({course: courseName(g), time1: s.time1, time2: s.time2});
        });
    });
    // ТЗ updated п.11: внутри дня занятия шли в порядке групп из ответа — сортируем по времени начала
    Object.values(byDay).forEach(day => {
        day.items.sort((a, b) => String(a.time1 || '').localeCompare(String(b.time1 || '')));
    });
    const weekRows = DAY_ORDER.filter(d => byDay[d]).map(d => ({
        key: d, day: byDay[d].dayName, items: byDay[d].items
    }));

    const weekColumns = [
        {title: <IntlMessage id={'studentSchedule.day'}/>, dataIndex: 'day', width: 80},
        {
            title: <IntlMessage id={'ordersPage.schedule'}/>, key: 'items',
            render: (_, r) => (
                <Flex vertical gap={4}>
                    {r.items.map((it, i) => (
                        <span key={i}>
                            {it.course}{it.time1 ? ` — ${it.time1}${it.time2 ? '–' + it.time2 : ''}` : ''}
                        </span>
                    ))}
                </Flex>
            )
        }
    ];

    return (
        <Modal
            open={open}
            onCancel={onClose}
            onOk={onClose}
            width={700}
            title={`${studentName || ''} — ${IntlMessageText.getText({id: 'ordersPage.schedule'})}`}
            footer={null}
        >
            {loading ? (
                <Flex justify="center" align="center" style={{minHeight: 150}}><Spin size="large"/></Flex>
            ) : (
                schedule.length === 0 ? <Empty description={<IntlMessage id={'noData'}/>}/> :
                    <Flex vertical gap={16}>
                        <Table bordered size="small" pagination={false} columns={weekColumns} dataSource={weekRows}/>
                        <Flex vertical gap={10}>
                            {schedule.map(g => (
                                <Card key={g.groupId} size="small">
                                    <Flex vertical gap={4}>
                                        <MyText strong>{courseName(g)}</MyText>
                                        <span><IntlMessage id={'category'}/>: {LocalName.getName(g.category)}</span>
                                        {g.teacherFullName &&
                                            <span><IntlMessage id={'ordersPage.teacher'}/>: {g.teacherFullName}</span>}
                                        <span><IntlMessage id={'ordersPage.schedule'}/>: {g.schedule || '—'}</span>
                                        {g.duration &&
                                            <span><IntlMessage id={'ordersPage.duration'}/>: {g.duration}</span>}
                                    </Flex>
                                </Card>
                            ))}
                        </Flex>
                    </Flex>
            )}
        </Modal>
    );
};

export default StudentScheduleModal;
